import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getToken } from '@/lib/api';

/**
 * ProtectedRoute - Wraps admin pages to enforce auth.
 *
 * Two distinct redirect modes:
 *   • No token at all              → /admin/login (silent — first-time visit)
 *   • Token present but EXPIRED    → /admin/login?expired=1&r=stale
 *     (so the login page shows "Your session has expired" instead of
 *     leaving the admin staring at a blank login screen wondering why)
 *
 * Note: We DO NOT clear the stale token here. Clearing during render
 * would be a side effect; React 18 Strict Mode renders twice and the
 * second pass would see no token → silent path, losing the "?expired=1"
 * query and the toast. AdminLogin.useEffect handles the cleanup when
 * it sees `?expired=1`.
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const hasToken = !!getToken();
  const valid = isAuthenticated();

  if (!valid) {
    if (hasToken) {
      return (
        <Navigate
          to="/admin/login?expired=1&r=stale"
          state={{ from: location.pathname }}
          replace
        />
      );
    }
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}
